export default __webpack_public_path__ + "static/media/img-04.df2f356f.jpg";